type MultyPrice = {
  price: string;
  min: string;
  max: string;
};

const buyingQty = {
  stockInput: undefined as
    | HTMLInputElement
    | undefined,
  incQt: undefined as HTMLElement | undefined,
  decQt: undefined as HTMLElement | undefined,
  total: undefined  as HTMLElement | undefined,
  multyPrice: (window as any).priceLogic as MultyPrice[],
  stockQty: 1,
  price: 0,
  min: 1,
  multiplier: 1,
  init() {
    this.set();
 
  
  },
 
  changeQty() {
    if (this.stockInput) {
      if (+this.stockInput.value < this.min) {
        this.stockInput.value = this.min.toString();     
      }else if(+this.stockInput.value% this.multiplier !== 0){
        this.stockInput.value = (Math.floor(+this.stockInput.value /  this.multiplier) *  this.multiplier).toString()
      }
      this.stockQty = +this.stockInput.value;

      this.setPrice();
    }
  },
  decrease() {

    if (this.stockQty > this.min && this.stockInput) {
      this.stockQty -= this.multiplier;
      this.stockInput.value = this.stockQty.toString();
      this.setPrice();
    }


  },
  increase() {
    if (this.stockInput) {
      this.stockQty += this.multiplier;  
      this.stockInput.value = this.stockQty.toString();
      this.setPrice();
    }


  },
  setInput() {
    if (this.incQt && this.decQt && this.stockInput) {
      const minQty = this.stockInput.dataset.min
      const multiplierQty = this.stockInput.dataset.multiplier
      if( minQty && +minQty > 1){
        this.min = +minQty
      }
      if(multiplierQty && +multiplierQty > 1){
        this.multiplier = +multiplierQty
      }

      this.stockQty = +this.stockInput.value;
      this.setPrice(); 
      this.stockInput.addEventListener("change", this.changeQty.bind(this));   
      this.decQt.addEventListener("click", this.decrease.bind(this));
      this.incQt.addEventListener("click", this.increase.bind(this));
    }
  },

  setPrice() {
    this.multyPrice.forEach((item) => {
      if (this.stockQty >= +item.min && this.stockQty <= +item.max && this.total) {
        this.total.innerText = "$" + (this.stockQty * +item.price).toFixed(2);
      }
    });
  },

  set() {
    window.addEventListener("resetQty", () => {
      (this.stockInput = document.querySelector(
        ".jsQtyInput"
      ) as HTMLInputElement),
        (this.incQt = document.getElementById("incQt") as
          | HTMLElement
          | undefined),
        (this.decQt = document.getElementById("decQt") as
          | HTMLElement
          | undefined),
        (this.total = document.getElementById("jsTotalPrice") as HTMLElement),    
      this.price = 0;
      this.multyPrice = (window as any).priceLogic as MultyPrice[],
      this.setInput();
      this.setPrice();
    });
  },
};

export default buyingQty;
